import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { RootState } from '../../../redux/store'
import Form from '../../../components/Form'
import FormItem from '../../../components/Form/FormItem'
import Button from '../../../components/General/Button'
import InputNumber from '../../../components/Inputs/InputNumber'
import InputText from '../../../components/Inputs/InputText'
import RawAutoComplete from '../../../components/Inputs/RawAutoComplete'
import useSnackBars from '../../../hooks/SnackbarConsumerHook'
import { formatPipe } from '../../../utils/utils'
import { toFixed } from 'accounting'

const AddItemToPurchaseForm: React.FC<IAddItemToPurchaseForm> = ({
  onSubmit,
  onClose,
  globalRate,
}) => {
  const form = useForm({
    defaultValues: {
      received: '0',
      cost: '0',
      amount: '1',
    },
  })

  const rates = useSelector((state: RootState) => state?.rates?.rates)

  const [selectedItem, setSelectedItem] = useState<any | null>(null)

  const [itemCost, setItemCost] = useState<number>(0)

  const { addAlert } = useSnackBars()

  // useEffect(() => {

  //   console.log("form...", form)

  // }, [form?.watch('cost')])

  useEffect(() => {
    console.log('form', form)

    form?.getValues('cost')
  }, [form?.watch])

  const onSubmitForm = (values: any) => {
    const amount = +formatPipe(`${values?.amount ?? 0}`, true, 0)
    const received = +formatPipe(`${values?.received ?? 0}`, true, 0)
    const cost = +formatPipe(`${values?.cost ?? 0}`, true)

    if (!selectedItem) {
      addAlert({
        message: 'Seleccione un producto',
        status: 'error',
      })
      return
    }

    if (received > amount) {
      addAlert({
        message: 'La cantidad recibida no puede ser mayor a la cantidad comprada.',
        status: 'error',
      })
    } else {
      onSubmit({ ...values, amount, received, cost })
    }
  }

  return (
    <div>
      <div className="flex flex-row justify-between items-center">
        <h2 className="text-primary dark:text-white font-semibold text-sm mb-3">
          Añadir nuevo producto
        </h2>
      </div>

      <Form
        form={form}
        onSubmit={(v) => {
          onSubmitForm({ ...v, item: selectedItem })
        }}
        classes="gap-x-6"
      >
        <RawAutoComplete
          classes="xl:col-span-6 lg:col-span-12"
          url="inventory/item/simple-search"
          bodyGet="items"
          queryParam="param"
          outsideParams={[`purchase=true`]}
          selectedValue={undefined}
          setSelectedValue={(v) => {
            if (v?.currency?.id === '2') {
              // Moneda es Bs, usar costo directamente
              form.setValue('cost', formatPipe(toFixed(v?.cost, 2)) || '0,00')
            } else {
              // Otra moneda, buscar su tasa y multiplicar
              const currencyRate = rates?.find((r: any) => r.id === v?.currency?.id)?.rate || '1'
              form.setValue(
                'cost',
                formatPipe(toFixed(+v?.cost * +currencyRate, 2)) || '0,00'
              )
            }
            setSelectedItem(v)
          }}
        />

        <FormItem
          name="received"
          classes="xl:col-span-6 lg:col-span-12"
          rules={{ required: 'Campo requerido' }}
        >
          {/* <InputText label="Recibido" /> */}
          <InputNumber label="Cantidad recibida" min={0} />
        </FormItem>

        <FormItem
          name="cost"
          classes="xl:col-span-6 lg:col-span-12"
          rules={{ required: 'Campo requerido' }}
        >
          {/* <InputText label="Costo" /> */}
          <InputNumber label="Costo en Bs (VEN)" min={0} addDecimals={true} />
        </FormItem>

        <FormItem
          name="amount"
          classes="xl:col-span-6 lg:col-span-12"
          rules={{ required: 'Campo requerido' }}
        >
          {/* <InputText label="Catidad" /> */}
          <InputNumber label="Cantidad comprada" min={1} />
        </FormItem>

        <div className="col-span-12 flex mt-2 justify-end">
          {selectedItem?.currency?.id === '1' ? (
            <h2 className="text-xs text-primary font-semibold">
              Costo unitario en USD (ref): {formatPipe(selectedItem?.cost)}
            </h2>
          ) : selectedItem && (
            <h2 className="text-xs text-primary font-semibold">
              Costo unitario en USD (ref): {formatPipe(toFixed(+selectedItem?.cost * +(rates?.find((r: any) => r.id === selectedItem?.currency?.id)?.rate || 1) / +(rates?.find((r: any) => r.id === '1')?.rate || 1), 2))}
            </h2>
          )}
        </div>

        <div className="col-start-3 col-span-9 flex space-x-2 mt-4 px-1 mt-10 row-start-8 block">
          {onClose && (
            <Button
              type="outline"
              classes="w-1/2 mr-4"
              onClick={() => onClose()}
              htmlType="button"
            >
              Cancelar
            </Button>
          )}
          <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
            Añadir
          </Button>
        </div>
      </Form>
    </div>
  )
}

interface IAddItemToPurchaseForm {
  onSubmit: (v: any) => void
  onClose: () => void
  globalRate: string
}

export default AddItemToPurchaseForm
